import axios from 'axios';

import { MVJ_API } from './Constants';
import { getJWTAuthToken } from './UserStore/UserSelectors';

const request =
  ({ headers: userHeaders = {}, method = 'GET', params = {}, ...options }) =>
  (_, getState) => {
    const jwtToken = getJWTAuthToken(getState());
    const headers = {
      ...userHeaders,
      Authorization: `Bearer ${jwtToken}`,
    };

    let paramsKey = 'data';
    if (method === 'GET') {
      paramsKey = 'params';
    }

    const config = {
      ...options,
      [paramsKey]: params,
      baseURL: options.baseURL || MVJ_API,
      headers,
      method: method.toLowerCase(),
    };

    return axios(config)
      .then(({ data, status }) => ({
        ...data,
        status,
      }))
      .catch((response) => Promise.reject(response));
  };

export default request;
